import { DeliveryCompanyModel } from '../../delivery_company/models/DeliveryCompanyModel'

export class ShipmentModel {
    id?:number = undefined
    idExternalChannel?:number = undefined
    idOrderItem?: number = undefined
    idDeliveryCompany?: number = undefined
    listPrice: number = 0
    price: number = 0
    shippingEstimate: string = ""
    shippingEstimateDate: string = ""
    description: string = ""
    deliveryCompany?: DeliveryCompanyModel = undefined;

    constructor(s?: Partial<ShipmentModel>) {
        Object.assign(this, s)

        this._parseDeliveryCompany()
    }

    private _parseDeliveryCompany():void {
        this.deliveryCompany = new DeliveryCompanyModel(this.deliveryCompany)
    }
}
